import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CHAT_SKILLS_QUERY_KEY } from 'src/UI/app-container/chats/useChatSkills';

export default function useDeleteTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (skillId: string) => api.delete(`/tenant/custom-skills/${skillId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] });
      queryClient.invalidateQueries({ queryKey: CHAT_SKILLS_QUERY_KEY });
    },
  });
}
